import { memo } from '@morphic-ts/common/es6/utils';
import * as t from 'io-ts';
import { IOTSType, IoTsURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const ioTsUnionInterpreter = memo(() => ({
    _F: IoTsURI,
    union: (items) => (_guards, name) => (env) => new IOTSType(t.union(items.map(x => x(env).type), name)) // TODO: fix (follow up: https://github.com/gcanti/io-ts/issues/312)
}));
